// src/com/dc_temp_break_his/DcTempBreakHisGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * DC_TEMP_BREAK_HIS Apollo Graphql
 * 차량의 온도 이상 이력
 * Project: NewTOP for cloud
 * 2024-12-05 13:42:08 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const DC_TEMP_BREAK_HIS_LIST_PART = gql`
fragment DcTempBreakHisListPart on DcTempBreakHis {
    dcCd
    storeId
    comId
    vehPlates
    gpsDatetime
    gpsTime
    vehInfoSeq
    dcName
    storeName
    comName
    tempF
    tempM
    tempR
    location
    breakTime
    checkNo
    resultTemp
    regDate
    regUser
    tsrTemp
    vehTypeId
    vehTypeName
    note
    tsrTempF
    tsrTempM
    tsrTempR
    transTypeCd
}
`;


export const LIST_DC_TEMP_BREAK_HIS = gql`
${DC_TEMP_BREAK_HIS_LIST_PART}
query ListDcTempBreakHis($date:String!) {
    dcTempBreakHisList(date:$date) {
        ...DcTempBreakHisListPart
    }
}
`;
